import { Skeleton, SkeletonProps, styled } from "@mui/material";
import { PropsWithChildren } from "react";
type SkeletonLoadingProps = SkeletonProps & {
    loading?: boolean;
};
const SkeletonStyle = styled(Skeleton)(() => ({}));
SkeletonStyle.defaultProps = {
    variant: "rounded",
    sx: { fontSize: "1.5rem" },
    animation: "wave",
};
const SkeletonLoading = ({ children, loading, ...props }: PropsWithChildren<SkeletonLoadingProps>) => {
    return loading ? <SkeletonStyle {...props} /> : children;
};

export default SkeletonLoading;
